import React, { useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import Title from '../../SpiderWebSite/components/Title'
import SideBar from '../SideBar'
import ContentMessage from '../ContentMessage'
import DialogAdd from './Add'
import { IMessage } from '../../store/messagerieSlice'
import { useSelector } from 'react-redux'
import { IReduxState } from '../../store'

export interface IFocusEcoleProps {
    selectedIndex: number;
    setSelectedIndex: (x: number) => void;
    filteredMessages: IMessage[];
    setFilteredMessages: (x: IMessage[]) => void
    handleSelectAllClick: any;
    handleClick: any;
}


export default function FocusEcole(props: IFocusEcoleProps) {
    const { selectedIndex, setSelectedIndex, filteredMessages, setFilteredMessages,handleSelectAllClick,handleClick } = props

    const messages = useSelector((state: IReduxState) => state.messagerie).messages;

    React.useEffect(() => {
        const newArray = [...messages]
        let messagesToDisplay = newArray;
        if (selectedIndex === 0) {
            setFilteredMessages(newArray);
        } else if (selectedIndex === 1) {
            messagesToDisplay = messages.filter(row => row.sentAt !== null);
        } else if (selectedIndex === 2) {
            messagesToDisplay = messages.filter(row => row.sentAt === null);
        } else if (selectedIndex === 3) {
            messagesToDisplay = messages.filter(row => row.messageArcived === 1);
        }
        setFilteredMessages(messagesToDisplay)
    }, [messages, selectedIndex])

    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Grid container spacing={3} style={{ borderRadius: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Title intitule='Gestion de notifications' />
                        <div style={{ marginTop: 15 }}>
                            <DialogAdd
                                setFilteredMessages={setFilteredMessages}
                                filteredMessages={filteredMessages}
                            />
                        </div>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={2} lg={2}>
                    <Box>
                        <SideBar
                            selectedIndex={selectedIndex}
                            setSelectedIndex={setSelectedIndex}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={10} lg={10}>
                    <Box style={{ height: "60vh", overflow: "auto" }}>
                        <ContentMessage
                            indexSideBarSelected={selectedIndex}
                            filteredMessages={filteredMessages}
                            setFilteredMessages={setFilteredMessages}
                            handleSelectAllClick={handleSelectAllClick}
                            handleClick={handleClick}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}
